<template>
  <div class="pc-isDetail-detail">
    <h2 v-if="isDetail.msgTitle == '新闻'">新闻正文</h2>

    <h2 v-else>{{ isDetail.msgTitle }}详情</h2>
    <div
      v-show="editUniversty == false"
      v-html="isDetail.content"
      class="detai-world"
    ></div>
    <div
      v-show="editUniversty == false"
      v-if="isDetail.content != null"
      v-html="isDetail.englishContent"
      class="detai-world"
    ></div>

    <div
      v-show="editUniversty == false"
      v-if="isDetail.content == null"
      class="detai-Null"
    >
      暂无内容
    </div>

    <div class="edit">
      <TemplateUeditor
        v-show="editUniversty == true"
        v-model="isDetail.content"
      />
    </div>
    <TranslateText
      v-show="editUniversty == true"
      :translateWord="isDetail.content"
       :translateEnglishWord="isDetail.englishContent"
      @returnTranslate="returnTranslate"
      @english="english"
      @chinese="chinese"
    />
    提示
    <h4 style="margin-bottom: 15px;" v-show="editUniversty == true">英文翻译</h4>
    <TemplateUeditor
      v-show="editUniversty == true"
      v-model="isDetail.englishContent"
    />
  </div>
</template>
<script>
import TemplateUeditor from "./Ueditor";
import { translate } from "./graphql/translate.gql";
import TranslateText from "./TranslateText";
export default {
  props: { isDetail: Object, editUniversty: Boolean },
  components: {
    TemplateUeditor,
    TranslateText,
  },
  data() {
    return {
      translate:{
      translateWorld:''
      }
    };
  },
  mounted() {
    this.worldTranslate()
  },
  methods: {
    worldTranslate(){
      // this.translateWorld=this.isDetail.content
      this.$set(this.translate,'translateWorld',this.isDetail.content)
    },
    returnTranslate(enContent,flag) {
      if(flag=='1'){
        this.$set(this.isDetail, "englishContent", enContent);
      }else if(flag=='2'){
        this.$set(this.isDetail, "content", enContent);
      }
    },
    english(){
      this.$set(this.translate,'translateWorld',this.isDetail.englishContent)
    },
    chinese(){
      this.$set(this.translate,'translateWorld',this.isDetail.content)
    }
  },
};
</script>
<style lang="scss" scoped>
//   院校详情
.pc-isDetail-detail {
  box-shadow: $boxshadow;
  padding: 35px 30px;
  margin-top: 40px;
  > h2 {
    border-bottom: 1px solid $border-color;
    font-size: 20px;
    padding-bottom: 15px;
    margin-bottom: 21px;
    color: $mainTitle;
  }

  // .detai-Null {
  // }
  .detai-world {
    margin-top: 20px;
  }
  // .changeEnglish {
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/template/EditDetail.vue